/**
 * The constructor's parameters are "injected" via AJS's IoC.
 *
 * @constructor
 */
const MessagingFactory = function ($resource, $window) {
    //-----------------------------------------------------------------------
    // EXPOSED API
    //-----------------------------------------------------------------------

    return {
        messagesList: $resource(
            __baseApiUrl__ +
                "/participant-web-services/rest/nonauth/bulletins/bulletinsForGrps/function/KP",
            {},
            {
                query: {
                    method: "GET",
                    isArray: true
                }
            }
        )
    };
};

MessagingFactory.$inject = ["$resource", "$window"];
export default MessagingFactory;
